module.exports = {
    language: {
        name: '中文'
    },
    header:{
        nav1:'首页',
        nav2:'关于DISRUN',
        nav3:'技术实力',
        nav4:'产品解决方案',
        nav5:'全球销售',
        nav6:'联系我们',
        nav2_1:'关于我们',
        nav2_2:'品牌文化',
        nav2_3:'专利资质',
        nav2_4:'企业动态',
        nav3_1:'技术特点',
        nav3_2:'技术专利',
        nav3_3:'视频播放',
        nav4_1:'酒店/餐饮行业',
        nav4_2:'食品与保健行业',
        nav4_3:'船舶/工厂车间',
        nav4_4:'医院/康复中心',
        nav6_1:'常见问题'

    },
    footer:{
        address1:'地址：',
        address2:'福建省 泉州市 丰泽区 东滨路       宏兴创业园',
        address3:'B栋3楼8318',
        email1:'邮箱',
        email2:'mryan@disrun.com',
        office1:'电话',
        office2:'0086-0595-28888337',
        icp1:'版权所有@2023泉州市六韬电子商务有限公司 ',
        icp2:'备案号：闽ICP备2023007557号-1'
    },
    home: {
        s2_1:"关于DISRUN",
        s2_2:"专业防滑鞋品牌",
        s2_3:"DISRUN迪丝纶是中国为数不多的专注止滑鞋领域的专业鞋类品牌，经过十来年的积累，DISRUN已推出一系列专业防滑鞋，包括：厨师鞋、护士鞋、安全鞋、生活鞋等，并由自主合作的工厂生产，持续向国内外市场输出高品质防滑鞋。</br></br>DISRUN拥有10多人的专业产品研发团队，可根据不同行业在湿滑地面环境工作的需要，采用不同材料进行研发和生产，DISRUN推出的产品具有高效防滑性能、穿着舒适、柔韧耐用、易于清洁等特点，目前，产品已广泛应用于酒店、餐饮、医疗与护理、食品与保健、船舶及工厂车间等各个行业。经过多年市场拓展，除了中国市场，DISRUN产品已远销美国、墨西哥、韩国、菲律宾、泰国、马来西亚、新加坡等10几个国家和地区。</br></br>DISRUN欢迎国内外市场的合作伙伴，秉承资源共享、合作共赢的经营理念，共同携手打造专业止滑鞋市场，持续为在湿滑地面工作的人们，提供稳定安全的行走解决方案，降低滑倒风险，共创价值，共谋发展。",
        s2_4:[{
            t1:'10年',
            t2:'+',
            t3:'止滑领域'
        },{
            t1:'10人',
            t2:'+',
            t3:'研发团队'
        },{
            t1:'10个',
            t2:'+',
            t3:'出口国家'
        }],
        s2_5:'了解DISRUN',
        s2_6:'http://cdncn.disrun.com/766b210c93494126afb965a644bf0017.mp4',

        s3_1:'技术实力',
        s3_2:'专利科技 专业防滑',
        s4_1:'产品解决方案',
        s4_2:'DISRUN产品广泛应用于各行业的工作场景',
        s4_3:'DISRUN产品广泛应用于各行业的工作场景',
        s4_01:'厨师',
        s4_02:'医护人员',
        s4_03:'食品与保健人员',
        s4_04:'服务员/保洁员/洗碗工',
        s4_05:'酒店/餐饮 厨房',
        s4_06:'医院/康复中心/手术室',
        s4_07:'船舶/工厂车间',
        s4_08:'各种湿滑环境',
        s5_1:'全球销售',
        s5_2:'DISRUN产品远销全球十几个国家和地区，受到客户的一致好评！',
        s5_3:'DISRUN产品远销全球十几个国家和地区<br/>受到客户的一致好评！',
        s5_4:["中国大陆","中国香港","中国台湾","韩国","日本","马来西亚","泰国","新加坡","加拿大","美国","墨西哥","印度尼西亚","越南","德国","英国"],
        s6_1:'合作客户',
        s6_2:'我们为知名企业提供优质的产品',
        test2: '中文'
    },
    program:{
        label:{1:"酒店/餐饮行业解决方案",2:'船舶/工厂车间解决方案',3:'食品与保健行业解决方案',4:'医院/康复中心解决方案'},
        banner:[
            {t1:'酒店/餐饮行业解决方案',
                t3:'在酒店餐饮行业中，厨房地面经常残留油和水等油污混合物，餐厅地面也有残留的油污，这两个重点工作区域的湿滑地面环境，容易导致厨师、洗碗工、清洁员、服务员等人员在工作行走中滑倒，DISRUN专业防滑鞋，防水防油设计，以及针对油水的止滑技术，可以提供稳定安全的行走解决方案。',
            t2:["在酒店餐饮行业中，厨房地面经常残留油和水等油污混合物，餐厅地面也有残留的油污，这两个重点工作区域的湿滑地面环境，容易导致厨师、洗碗工、清洁员、服务员等人员在工作行走中滑倒，",
            "DISRUN专业防滑鞋，防水防油设计，以及针对油水的止滑技术，可以提供稳定安全的行走解决方案。"]},
            {t1:'船舶/工厂车间解决方案',
                t3:'船舶/机械厂/清洁液厂等工厂车间，因作业环境特殊，地面中的水、油等混合物形成的湿滑环境，容易导致工人滑倒，DISRUN专业防滑鞋，针对油水的止滑技术，可以提供稳定安全的行走解决方案。',
                t2:["船舶/机械厂/清洁液厂等工厂车间，因作业环境特殊，地面中的水、油等混合物形成的湿滑环境，容易导致工人滑倒",
                "DISRUN专业防滑鞋，针对油水的止滑技术，可以提供稳定安全的行走解决方案。"]},
            {t1:'食品与保健行业解决方案',
                t3:'食品厂/烘焙厂/饮料制造厂/保健用品制造厂/药厂等生产作业车间地面，经常伴有油滑，生产作业人员一不小心容易滑倒，DISRUN专业防滑鞋，针对油、油脂等设计的止滑技术，可以提供稳定安全的行走解决方案。',
                t2:["食品厂/烘焙厂/饮料制造厂/保健用品制造厂/药厂等生产作业车间地面，经常伴有油滑，生产作业人员一不小心容易滑倒",
               "DISRUN专业防滑鞋，针对油、油脂等设计的止滑技术，可以提供稳定安全的行走解决方案。"]},
            {t1:'医院/康复中心解决方案',
                t3:'医院/康复中心/诊所/药店等工作环境中，部分地面环境伴有液体，因较为湿滑容易导致滑倒，DISRUN专业防滑鞋，专为医院/康复中心等工作人员设计了适应长期久站、专业止滑的防滑鞋，可以提供稳定安全的行走解决方案。',
                t2:["医院/康复中心/诊所/药店等工作环境中，部分地面环境伴有液体，因较为湿滑容易导致滑倒",
               "DISRUN专业防滑鞋，专为医院/康复中心等工作人员设计了适应长期久站、专业止滑的防滑鞋，可以提供稳定安全的行走解决方案。"]},
            ]
    },
    product: {
        test: '产品中文'
    },
    about:{
        banner:'关于DISRUN',
        t1:'DISUN迪丝纶是中国为数不多的专注止滑鞋领域的专业鞋类品牌，经过十多年的市场拓展，除了中国市场，DISRUN产品已远销：韩国、日本、以及北美、东南亚等国家和地区，经过多年持续研发投入，DISRUN已在国内拥有多项产品专利。',
        cell:[{
            t1:'技术差异化',
            t2:'为了让在湿滑环境工作的人们提高效率和保持稳定的安全感，并减少因滑倒造成各种损失和损伤，DISRUN专业防滑鞋产品应运而生，通过研发专业全面的油水防滑技术，解决湿滑环境下的行走安全痛点，产品一经推出，受到广大消费者的青睐和喜爱。'
        },{
            t1:'品牌创新化',
            t2:'DISRUN迪丝纶品牌从创立之初，便以国际品牌为塑造标准，以技术为核心，质量为根基，持续增强品牌生命力，产品已广泛应用于酒店、餐饮、医疗与护理、食品与保健、船舶及工厂车间等各行业。'
        },{
            t1:'市场全球化',
            t2:'为拓展国内和国际业务，DISRUN积极参加各类专业展会，劳保展、酒店用品与食品展、食品饮料展、跨境电商选品会等等，横跨国内、日韩、东南亚及北美等各种展会。'
        }],
        t2:'品牌简介',
        c2:'DISRUN迪丝纶是中国为数不多的专注止滑鞋领域的专业鞋类品牌，经过十来年的积累，DISRUN已推出一系列专业防滑鞋，包括：厨师鞋、护士鞋、安全鞋、生活鞋等，并由自主合作的工厂生产，持续向国内外市场输出高品质防滑鞋。<br/><br/>DISRUN拥有10多人的专业产品研发团队，可根据不同行业在湿滑地面环境工作的需要，采用不同材料进行研发和生产，DISRUN推出的产品具有高效防滑性能、穿着舒适、柔韧耐用、易于清洁等特点，目前，产品已广泛应用于酒店、餐饮、医疗与护理、食品与保健、船舶及工厂车间等各个行业。经过多年市场拓展，除了中国市场，DISRUN产品已远销美国、墨西哥、韩国、菲律宾、泰国、马来西亚、新加坡等10几个国家和地区。<br/><br/>DISRUN欢迎国内外市场的合作伙伴，秉承资源共享、合作共赢的经营理念，共同携手打造专业止滑鞋市场，持续为在湿滑地面工作的人们，提供稳定安全的行走解决方案，降低滑倒风险，共创价值，共谋发展。',
        t3:'技术简介',
        c3:'DISRUN拥有独特的油水防滑技术W.O.S.R (WATER & OIL SLIP RESISTANT)，鞋底通过采用精密模具和特殊化学配方，实现专业全面的防滑技术。</br><br/>INTERTEK (天祥) 精密实验室测试认可的摩擦系数，评估防滑性能高于F1677:2005 MARK II 标准，评估防滑性能高于欧标SRC标准。</br><br/>DISRUN专业防滑鞋系列产品，适用于酒店、餐饮、医疗与护理、食品与保健、船舶、工厂车间等湿滑地面工作环境。',
        t4:'选择专业防滑鞋,能带来什么价值',
        c4:'在酒店、餐饮、医疗与护理、食品与保障、船舶、工厂车等各行业的湿滑地面环境工作的人群，每天都可能发生滑倒的风险，滑倒的潜在风险非常之高，据相关数据显示，在中国，每年20%的增长率发生滑倒事故，滑倒所造成的骨折、扭伤、烫伤、重伤等住院数据比例占全部的35%，滑倒已成为在湿滑地面环境工作人群的最大潜在风险。<br/>',
        c4_1:'选择专业防滑鞋， 能为我们带来',
        c4_01:'1.能最大限度减少滑倒事故的发生 ',
        c4_02:'2.能降低员工因滑倒受伤向企业索赔的风险',
        c4_03:'3.能直接有效地提高员工的工作效率',
        t8:'发展里程碑',
        miles:[{
            t1:'1993年',
            t2:'1993',
            t3:'SensFoot公司在韩国釜山成立<br>F.W.T.防滑专利技术在韩国釜山研发成功。',
        },{
            t1:'1995年',
            t2:'1995',
            t3:'成为全球知名运动品牌和户外品牌战略合作供应商',
        },{
            t1:'1998年',
            t2:'1998',
            t3:'全面深入研究防滑鞋技术',
        },{
            t1:'2003年',
            t2:'2003',
            t3:'成为防滑鞋行业领导品牌，获韩国最佳品牌',
        },{
            t1:'2006年',
            t2:'2006',
            t3:'登陆中国并建立SensFoot中国工厂',
        },{
            t1:'2010年',
            t2:'2010',
            t3:'SensFoot防滑鞋正式登陆中国市场',
        },{
            t1:'2014年',
            t2:'2014',
            t3:'成为中国地区防滑鞋领导品牌',
        }]

    },
    tech:{
        banner:'技术实力',
        t1:'专业全面的油水防滑技术（W.O.S.R）',
        c1:'DISRUN拥有独特的油水防滑技术W.O.S.R (WATER & OIL SLIP RESISTANT), 鞋底通过采用精密模具和特殊化学配方，实现专业全面的防滑技术。<br/><br/>INTERTEK (天祥) 精密实验室测试认可的摩擦系数，评估防滑性能高于F1677:2005 MARK II 标准，评估防滑性能高于欧标SRC标准。<br/><br/>DISRUN专业防滑鞋系列产品，适用于酒店、餐饮、医疗与护理、食品与保健、船舶、工厂车间等湿滑地面工作环境。',
        t2:'DISRUN专业防滑鞋，为行走安全提供稳定保障',
        d1:'中国专利设计',
        d2:'ZL.202022499758.8',
        d3:'通过几何花纹设计，结合精密模具和特殊化学配方技术，在湿滑的地板表面上产生强烈的抓地力，实现高效的止滑效果。',
        d_list:[
            {
                t1:'完整保护',
                c1:'鞋头设计完整保护，防止掉落的热水、油等杂物，在危险的湿滑情况下，提供行走安全的保障。',
            },
            {
                t1:'宽松舒适',
                c1:'鞋面采用EVA，重量轻且耐用，设计宽松，加上可拆卸的柔软高弹海绵鞋垫，支撑性强且舒适度高。',
            },
            {
                t1:'易于清洁',
                c1:'鞋面的内部、外部和鞋垫完全易于清洗，清洗后晾干，避免高温直晒。',
            }
        ],
        t_list:[
           'DISRUN防滑性能高于ASTM（美国测试与材料协会）F1677:2005 MARK II防滑测试标准，它将帮助你舒适且安全的完成工作。',
           'DISRUN采用进口环保材料，无刺激性味道，易清洗，可快干。',
           'DISRUN采用进口环保无味EVA和止滑橡胶，整鞋轻盈，穿着舒适，柔韧耐用。',
           'DISRUN止滑橡胶胶底拥有中国专利，能在各种类型的潮湿、油滑的地板表面展现强大的抓地力，实现高止滑效果。专为酒店、餐饮、医疗与护理、食品与保健、船舶、工厂车间等各行业设计。',
        ],
        cell:[{
            t1:'健康环保',
            t2:'使用环保无味EVA',
            t3:'使用环保无味进口EVA材料，能瞬间吸收和分散外界给足底部分的冲击，为体能保存与体能转换提供了良好的循环作用和更好的舒适感，有效的缓解足部疲劳感。'
        },{
            t1:'人性化设计',
            t2:'专设鞋底透水孔&按摩纹路',
            t3:'鞋底专设两个透水孔，解除鞋内积水，明显保持脚部接触面的干爽。'
        },{
            t1:'科技防滑',
            t2:'应用F.W.T.防滑专利技术',
            t3:'F.W.T.防滑专利技术迅速引导水膜分散，无论在潮湿地板、大理石、瓷砖或沾有水分、油污、洗涤剂的地面上行走，防滑效果甚佳。'
        }]
    },
    news:{
        'nav1':'全部新闻',
        'nav2':'公司动态',
        'nav3':'行业新闻',
    },
    sales:{
        nav:'全球销售',
    },
    contact:{
        banner:'联系我们',
        shop:{
            s1:'迪丝纶营销中心',
            s2:'泉州市六韬电子商务有限公司',
            s3:'电话',
            s3_1:'0086-0595-28888337',
            s4:'邮箱',
            s4_1:'mryan@disrun.com',
            s5:'地址',
            s5_1:'福建 泉州市 丰泽区 东滨路 1604号宏兴创业园B栋3楼8318',
        },
        title:'在线留言',
        ps:'留下您的意见/反馈便于我们了解您的需求，我们后续将会与您取得联系',
        ps1:'留下您的意见/反馈便于我们了解您的需求<br/>我们后续将会与您取得联系',
        ps2:'我们后续将会与您取得联系',
        q1:'联系人',
        q2:'联系电话',
        q3:'联系单位',
        q4:'留言内容',
        p1:'请输入您的姓名（称呼）',
        p2:'请输入您的电话',
        p3:'请输入您的单位名称',
        p4:'请输入您的详细的需求内容',
        m1:'DISRUN迪丝纶营销中心',
        t1:'请填写完整',
        t2:'联系电话格式不正确',
        t3:'提交成功',
        submit:'提交'
    },
    common:{
        more:'了解更多',
        date_list:'暂无数据'
    },
    culture:{
        t1:'迪丝纶',
        t2:'我们的故事',
        c1:'我们是DISRUN迪丝纶品牌的创始团队，是一群有着“匠人精神”追求的年轻人。<br/><br/>多年前，在一次商务聚会中，我们的一位朋友，讲述了他的经历，他在一次差旅中，洗完澡从酒店淋浴间走出来，由于地面湿滑，一不小心，他瞬间滑倒在地，造成臀部骨折，幸亏他被及时送到医院救治，否则后果不堪设想，这次惨痛经历让他心有余悸。<br/><br/>故事的背后，让我们萌生了设计研发一款能在湿滑地面安全行走的防滑鞋，让人们能够在湿滑地面安全行走，减少因受伤带来的风险和伤害。<br/><br/>经过多年的持续投入和研究，我们针对湿滑地面研发的止滑橡胶配方技术，进行了多次迭代升级，最终推出了DISRUN专业全面的油水防滑技术，并推动这项技术，应用到为不同湿滑环境所设计的专业防滑鞋。<br/><br/>在研究中，我们发现，厨房地面的油、水湿滑程度更为突出，因此，我们也更加专注在油水止滑的防滑系列产品的研发和投入。我们希望，DISRUN专业防滑鞋，能持续为在湿滑环境工作的人们，提供稳定安全行走的保障，帮助他们安全、舒适地完成工作，让他们更加自信地迈出每一步，迎接每一天的挑战。',
        st_1:'我们的使命',
        sc_1:'持续为在湿滑环境工作的人们<br/>提供稳定安全行走的保障',
        st_2:'我们的愿景',
        sc_2:'成为受人欢迎和尊重的专业鞋品牌',
        st_3:'可持续发展',
        sc_3:'我们一直致力于可持续发展，从产品设计到生产，秉承保护地球环境的理念，采用环保的原材料，并在生产环节中不断优化生产工艺，减少浪费。当然，我们还会根据用户的反馈，不断尝试创新的方法，包括减轻产品的重量、提高产品的透气性、防水性和舒适度等等，我们将继续努力，持续为地球环境保护做出应有的贡献。',

    },
    detail:{
        nav1:'行业新闻',
        nav2:'新闻详情',
        nav3:'公司动态',
        t1:'发布时间',
        t2:'上一篇',
        t3:'下一篇'
    },
    faq:{
        banner:'常见问题',
        banner1:'DISRUN专业全面的油水防滑技术，帮助你安全、舒话地完成工作',
        banner2:'DISRUN专业全面的油水防滑技术，帮助你安全、舒话地完成工作',
        q1:'为谁而设计？',
        p1:'DISRUN专为在湿滑环境工作的人们而设计，无论是厨师、清洁员、服务员、医护人员，还是在食品厂、饮料厂、机械厂、船舶、实验室、手术室等的工作人员，您能想到的，我们在设计鞋款时，已经考虑了您的具体需求。',
        q2:'尺码如何选择？',
        p2:'我们提供了欧洲尺码和国际尺码，不同材质和风格的鞋款，在设计时采用了不同的码差。总体上，DISRUN的鞋款，设计得比普通鞋款略微宽松，以便为一天长期久站的双脚提供更舒适的空间。请根据我们提供的尺码信息表进行选择，我们可以随时提供更换服务。',
        q3:'有哪些功能？',
        p3:'DISRUN防滑鞋，采用了DISRUN专业全面的油水防滑技术，可以为在油、油脂、油水混合物、洗涤液等各种常见湿滑地面上的行走，提供高效的止滑效果，止滑性能达到并超过ASTM止滑标准和SRC止滑标准。<br/>DISRUN防滑鞋，可以提供防水、防泼水、耐油、透气性、易清洁、耐弯折、防砸等功能性选择，可以根据您的工作环境需求，选择相应的鞋款。',
        q4:'使用寿命多久？',
        p4:'DISRUN防滑鞋作为工作中的消耗品之一，一般寿命为6-12个月，因人而异，1年可能使用1-3双，鞋子的使用寿命也与地面湿滑程度有关，清洁地面时残留的化学洗涤液，也有可能侵害止滑橡胶的粘合度，影响防滑鞋使用寿命。DISRUN防滑鞋为您工作中提供稳定安全的行走保障，需要及时关注止滑橡胶片的磨损程度，鞋面损耗程度，及时清理止滑橡胶片的残留物，保持清洁，请勿暴晒，可以延长鞋品的使用寿命。',
    }
}
